<div class="flex justify-center items-center h-screen">
    @if (downloadFilePath) {
        <a [href]="downloadFilePath" target="_blank">
            <p-button label="Download File" icon="pi pi-download" />
        </a>
    } @else {
        <p-progressSpinner />
    }
</div>